//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
//#region comment metod

const PostCommentTicketAdd = (data: any): Promise<any> =>
  request({
    url: ApiURL.Command.PostCommentTicketAdd,
    method: RequestType.POST,
    data,
  });
const PostAssigToMe = (data: any): Promise<any> =>
  request({
    url: ApiURL.Command.PostCommentAssignToMe,
    method: RequestType.PUT,
    data,
  });

const PostCommentStatusUpdate = (data: any) =>
  request({
    url: ApiURL.Command.PostCommentStatusUpdate,
    method: RequestType.POST,
    data,
  });
const DeleteCommentTicket = (data: any) =>
  request({
    url: ApiURL.Command.DeleteCommentTicket + "/" + data + "/remove",
    method: RequestType.DELETE,
    data,
  });
const GetReviewsSummaries = (data: any) =>
  request({
    url: ApiURL.Command.GetReviewsSummaries,
    method: RequestType.POST,
    data,
  });
const AssignOperatorReviewSummary = (data: any) =>
  request({
    url: ApiURL.Command.AssignOperatorReviewSummary,
    method: RequestType.POST,
    data,
  });
const UpdateReviewsSummary = (data: any) =>
  request({
    url: ApiURL.Command.UpdateReviewsSummary,
    method: RequestType.POST,
    data,
  });
const PostAssigToMeV2 = (data: any): Promise<any> =>
  request({
    url: ApiURL.Command.PostCommentAssignToMeV2,
    method: RequestType.PUT,
    data,
  });
const PostCommentStatusUpdateV2 = (data: any) =>
  request({
    url: ApiURL.Command.PostCommentStatusUpdateV2,
    method: RequestType.POST,
    data,
  });
const CreateRejectPhotoReason = (data: any) =>
  request({
    url: ApiURL.Command.CreateRejectPhotoReason,
    method: RequestType.POST,
    data,
  });
const UpdateRejectPhotoReason = (data: any) =>
  request({
    url: ApiURL.Command.UpdateRejectPhotoReason,
    method: RequestType.PUT,
    data,
  });
const DeleteRejectPhotoReason = (data: any) =>
  request({
    url: ApiURL.Command.DeleteRejectPhotoReason,
    method: RequestType.DELETE,
    data,
  });
const CommentCommand = {
  PostCommentTicketAdd,
  PostCommentStatusUpdate,
  DeleteCommentTicket,
  PostAssigToMe,
  GetReviewsSummaries,
  AssignOperatorReviewSummary,
  UpdateReviewsSummary,
  PostAssigToMeV2,
  PostCommentStatusUpdateV2,
  CreateRejectPhotoReason,
  UpdateRejectPhotoReason,
  DeleteRejectPhotoReason,
};

export default CommentCommand;
